module.exports = __webpack_public_path__ + "static/img/sandtable.f70af77d.png";